import { useEffect, useState } from 'react';
import { tokenService } from '@core/services/Token.service';

const useAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(() =>
    tokenService.isAuthenticated.getValue()
  );

  useEffect(() => {
    const subscription = tokenService.isAuthenticated.asObservable().subscribe({
      next(payload) {
        setIsAuthenticated(payload);
      }
    });

    return () => {
      subscription.unsubscribe();
    };
  }, []);

  return { isAuthenticated } as const;
};

export { useAuth };
